import { useSystemConfiguration } from '@/hooks/theme/useSystemConfiguration';
import UserIdentitiesFormContentPersonalIdentityLookUp from '@starsoft/common/components/KYC/UserIdentity/Form/Content/PersonalIdentityLookUp';
import { KycIdentityOriginId } from '@starsoft/common/enums';
import useTranslation from 'next-translate/useTranslation';

export default function AuthModalContentIdentifierInput() {
  const { t } = useTranslation('common');
  const { originId } = useSystemConfiguration();

  if (originId?.toString() !== KycIdentityOriginId.Brazil?.toString()) {
    return null;
  }

  return (
    <UserIdentitiesFormContentPersonalIdentityLookUp
      externalOriginId={originId}
      minimalForm
    />
  );
}
